export default "__VITE_ASSET__07104dae__"